import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromContacts from '../reducers/contacts.reducer';

const getContactsState = createSelector(
  fromFeature.getProductsState,
  (state: fromFeature.DashboardState) => state.contacts
);

const getContactsEntities = createSelector(getContactsState, fromContacts.getContactsEntities);

export const getContactsLoaded = createSelector(getContactsState, fromContacts.getContactstLoaded);

export const getContacts = createSelector(getContactsEntities, (entities) => {
  return Object.keys(entities).map((username) => entities[username]);
});

const getPendingContactsEntities = createSelector(getContactsState, fromContacts.getPendingContacts);

export const getPendingContacts = createSelector(getPendingContactsEntities, (entities) => {
  return Object.keys(entities).map((pk) => entities[parseInt(pk, 10)]);
});

export const getContactsById = (id: number) => createSelector(getContactsEntities, (contacts) => contacts[id]);

export const getPendingContactById = (id: number) =>
  createSelector(getPendingContactsEntities, (contacts) => contacts[id]);

const getInvitesEntities = createSelector(getContactsState, fromContacts.getInvites);

export const getInvites = createSelector(getInvitesEntities, (entities) => {
  return Object.keys(entities).map((pk) => entities[parseInt(pk, 10)]);
});

export const getInvitesById = (id: number) => createSelector(getInvitesEntities, (contacts) => contacts[id]);
